class SliderAutoplay {
  constructor (slider) {
    this.slider = slider;
    this.activeTimeout = null;
    this.autoplay = true;
    this.observer = new IntersectionObserver(
      (entries) => {
        this.observerHandler(entries);
      },
      {
        root: null,
        rootMargin: '-15%',
      }
    );
  }
  startAutoplay (slider) {
    const currSlider = slider.find('.oxygen-unslider-container');
    const sliderObj = currSlider.data('unslider');
    const delay = sliderObj.options.delay;
    // append progress bar to pagination
    currSlider.siblings('.unslider-nav').find('li').append('<span></span>');
    currSlider.siblings('.unslider-nav').find('li span').css('animation-duration',`${delay}ms`);
    this.activeTimeout = setTimeout(() => {
      sliderObj.next();
    }, delay);
  }
  sliderOnChange (slider) {
    const currSlider = slider.find('.oxygen-unslider-container');
    const sliderObj = currSlider.data('unslider');
    const delay = sliderObj.options.delay;
    currSlider.on('unslider.change', () => {
      if(this.autoplay) {
        clearTimeout(this.activeTimeout);
        this.activeTimeout = setInterval(() => {
          currSlider.data('unslider').next();
        }, delay);
      }
    });
  }
  paginationClickFunc (slider) {
    const dots = slider.find('.unslider-nav li');
    dots.on('click', () => {
      slider.addClass('pagination-clicked');
      clearTimeout(this.activeTimeout);
      this.autoplay = false;
    });
  }
  observerHandler(entries) {
    if (entries[0].isIntersecting) {
      this.startAutoplay(this.slider);
      this.sliderOnChange(this.slider);
      this.paginationClickFunc(this.slider);
      this.observer.disconnect();
    }
  }
  init () {
    this.observer.observe(this.slider[0]);
  }
}

$(() => {
  const sliders = $('.slider-autoplay');
  if (sliders.length == 0) {
    return;
  }
  sliders.each((id, slider) => {
    const sliderEl = $(slider);
    const sliderAutoplay = new SliderAutoplay(sliderEl);
    sliderAutoplay.init();
  });
});
